import React from 'react';
import A11ySvg from 'components/A11ySvg';
import './AddGiphyIcon.css';

function AddGiphyIcon({ className = '', size = 30, alt = '', label = '' }) {
  const setClassName = `add-giphy-icon ${className}`.trim();
  return (
    <span className={setClassName}>
      <A11ySvg
        className={`size-${size}`}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 31 24"
        alt={alt}
      >
        <g transform="translate(-381 -106)">
          <path
            className="fill"
            d="M7619.875,188.875h-21a5.006,5.006,0,0,1-5-5v-14a5.006,5.006,0,0,1,5-5h21a5.006,5.006,0,0,1,5,5v14A5.006,5.006,0,0,1,7619.875,188.875Zm-5.427-16.1a.426.426,0,0,0-.254.065.341.341,0,0,0-.084.274v8.605c0,.123.208.208.637.26l.611.027a6.831,6.831,0,0,0,.813-.059c.324-.038.488-.119.488-.241v-3.133h1.6c.14,0,.208-.329.208-1.007s-.074-1.008-.22-1.008h-1.586v-1.481h2.378c.148,0,.22-.376.22-1.15s-.072-1.152-.22-1.152Zm-9.92-.117a4.011,4.011,0,0,0-3.133,1.261,4.739,4.739,0,0,0-1.131,3.276,5.055,5.055,0,0,0,1.158,3.588,4.009,4.009,0,0,0,3.041,1.223,8.361,8.361,0,0,0,1.8-.176,3.244,3.244,0,0,0,1.047-.358l.052-4.068c0-.13-.166-.222-.494-.274l-.507-.038a4.287,4.287,0,0,0-.624.057c-.25.04-.377.121-.377.241l-.025,1.768c0,.225-.226.339-.67.339a1.569,1.569,0,0,1-1.185-.566,2.4,2.4,0,0,1-.513-1.657,2.263,2.263,0,0,1,.5-1.613,1.736,1.736,0,0,1,1.3-.519,2.441,2.441,0,0,1,.7.109,1.646,1.646,0,0,1,.488.209.387.387,0,0,0,.233.1c.075,0,.192-.085.358-.26a2.293,2.293,0,0,0,.442-.787,2.565,2.565,0,0,0,.2-.811,3.654,3.654,0,0,0-.013-.39,2.006,2.006,0,0,0-1.007-.475A7.136,7.136,0,0,0,7604.528,172.658Zm4.03,6.981c-.146,0-.247.188-.3.559a3.052,3.052,0,0,0,0,1.119c.052.371.152.559.3.559h4.382c.147,0,.25-.183.312-.559a3.052,3.052,0,0,0,0-1.119c-.062-.376-.165-.559-.312-.559h-.911v-4.627h.871c.146,0,.247-.188.3-.559a3.052,3.052,0,0,0,0-1.119c-.054-.371-.155-.559-.3-.559h-4.367c-.147,0-.252.188-.312.559a3.885,3.885,0,0,0,0,1.119c.059.371.164.559.312.559h.922v4.627Z"
            transform="translate(-7212.875 -58.875)"
          />
        </g>
      </A11ySvg>
      {label && <span className="add-giphy-label">{label}</span>}
    </span>
  );
}

export default AddGiphyIcon;
